import React from "react";
import { motion } from "framer-motion";
import "./Contact.css";
import { ImFacebook, ImTwitter, ImInstagram } from "react-icons/im";
import { SiTiktok } from "react-icons/si";
export default function Contact() {
  return (
    <div className="Contact">
      <div className="SocialBox">
        <div className="LeftBox">
          <h2>Facebook</h2>
        </div>
        <div className="RightBox">
          <ImFacebook size={30}></ImFacebook>
        </div>
      </div>

      <div className="SocialBox">
        <div className="LeftBox">
          <h2>Twitter</h2>
        </div>
        <div className="RightBox">
          <ImTwitter size={30}></ImTwitter>
        </div>
      </div>

      <div className="SocialBox">
        <div className="LeftBox">
          <h2>Instagram</h2>
        </div>
        <div className="RightBox">
          <ImInstagram size={30}></ImInstagram>
        </div>
      </div>

      <div className="SocialBox">
        <div className="LeftBox">
          <h2>Tiktok</h2>
        </div>
        <div className="RightBox">
          <SiTiktok size={30}></SiTiktok>
        </div>
      </div>
    </div>
  );
}
